<mat-toolbar color="primary" class="apearAnimation flex-row flex content-between relative rounded-md">
  <span class="font-semibold">Soporte</span>
</mat-toolbar>


<div
  fxLayout="column"
  fxLayoutAlign="space-arround stretch"
  fxLayoutGap="10px"
  fxLayoutWrap="wrap"
  class="stats-cards apearAnimation"
>

<mat-card class="dashboard-card" flex>
  <mat-card-header>
    <mat-card-title> Nuevo Soporte </mat-card-title>
  </mat-card-header>
  <mat-card-content class="dashboard-card-content">
    <div>
      <mat-form-field
      appearance="outline" 
        class="example-full-width"
        style="min-width: 200px; width: 40%; margin-right: 10px"
      >
        <mat-label>Usuario</mat-label>
        <input
          matInput
          placeholder="Nombre"
          value="AA"
          disabled
        />
      </mat-form-field>

      <mat-form-field
      appearance="outline" 
      class="example-full-width"
      style="min-width: 200px; width: 40%; margin-right: 10px"
    >
      <mat-label>Titulo</mat-label>
      <input
        matInput
        placeholder="Titulo"
        value=""
      />
    </mat-form-field>

      <mat-form-field
      appearance="outline" 
        style="min-width: 200px; width: 40%; margin-right: 10px"
      >
        <mat-label>Prioridad</mat-label>
        <mat-select>
          <mat-option value="1"> Baja </mat-option>
          <mat-option value="2"> Media </mat-option>
          <mat-option value="3"> Alta </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
      appearance="outline" 
        class="example-full-width"
        style="min-width: 200px; width: 100%; margin-right: 10px"
      >
        <mat-label>Descripcion del soporte</mat-label>
        <textarea matInput placeholder="Descripcion" rows="3"></textarea>
      </mat-form-field>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <button mat-raised-button color="primary">Enviar soporte</button>
  </mat-card-actions>
</mat-card>


<br />
<mat-divider></mat-divider>
<br />

<mat-card class="dashboard-card">
  <mat-card-header>
    <mat-card-title> Historico </mat-card-title>
  </mat-card-header>
  <mat-card-content class="dashboard-card-content">
    <div>
      <mat-form-field mappearance="outline">
        <mat-label>Filtro</mat-label>
        <input
          matInput
          (keyup)="applyFilter($event)"
          placeholder="Buscar"
          #input
        />
      </mat-form-field>

      <table mat-table [dataSource]="dataSource" class="mat-elevation-z0">
        <!-- Position Column -->
        <ng-container matColumnDef="titulo">
          <th mat-header-cell *matHeaderCellDef>titulo</th>
          <td mat-cell *matCellDef="let element">{{ element.titulo }}</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="fecha">
          <th mat-header-cell *matHeaderCellDef>fecha</th>
          <td mat-cell *matCellDef="let element">{{ element.fecha }}</td>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="prioridad">
          <th mat-header-cell *matHeaderCellDef>prioridad</th>
          <td mat-cell *matCellDef="let element">
            {{ element.prioridad }}
          </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="estado">
          <th mat-header-cell *matHeaderCellDef>estado</th>
          <td mat-cell *matCellDef="let element">{{ element.estado }}</td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="descripcion">
          <th mat-header-cell *matHeaderCellDef>descripcion</th>
          <td mat-cell *matCellDef="let element">{{ element.descripcion }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>



</div>

<br />
<mat-divider></mat-divider>
<br />